

import { useParams } from "react-router-dom";
import { Grid, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { separadorMillares } from "../../../hooks/useMillares";
import { useGastoXID } from "../../../hooks/cache";
import { LayoutTabla } from "../../layouts";
import { fechaConHora } from "../../../helpers/prepararFecha";


export const DetallesDeGasto = () => {


    const { id } = useParams();
    const { data } = useGastoXID(id);


    return (

        <Grid container sx={{mb:3}}>
            {(data) &&
            <LayoutTabla>
                <TableHead >
                    <TableRow >
                        <TableCell sx={{width:'20%'}}>Fecha</TableCell>
                        <TableCell sx={{width:'20%'}}>Proveedor</TableCell>
                        <TableCell sx={{width:'15%'}}>TOTAL</TableCell>
                        <TableCell sx={{width:'15%'}}>ABONOS</TableCell>
                        <TableCell sx={{width:'15%'}}>DEUDA</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        
                        <TableCell>{ fechaConHora(data.fecha) }</TableCell>
                        <TableCell>{ data?.proveedor.nombre }</TableCell>
                        <TableCell>{ `$${separadorMillares(data.total)}` }</TableCell>
                        <TableCell>{ `$${separadorMillares(data.total - data.saldo)}` }</TableCell>
                        <TableCell>{ `$${separadorMillares(data.saldo)}` }</TableCell>
                    </TableRow>
                </TableBody>
            </LayoutTabla>
            }
        </Grid>
    )
}
